import { Key } from '../constants';
export const createRequestFirstPart = () => [Key.REQUEST_STATE];
export const createRequestByOrderIndexFirstPart = (orderId) => [Key.REQUEST_BY_ORDER_INDEX, orderId];
export const createRequestByMarketMakerIndexFirstPart = (marketMaker) => [Key.REQUEST_BY_MAKER_INDEX, marketMaker];
export const createRefundIndexFirstPart = () => [Key.REQUEST_REVERSE_INDEX];
export const createRefundByMarketMakerIndexFirstPart = (marketMaker) => [Key.REQUEST_REVERSE_INDEX, marketMaker];
export const createNewSwapActionFirstPart = () => [Key.NEW_ACTION];
export const createHandledSwapActionFirstPart = () => [Key.HANDLED_ACTION];
export const createL1TxInfoFirstPart = (user) => [Key.L1_TX_INFO, user];
export const createRequestKey = (id) => ({
    first_part: createRequestFirstPart(),
    second_part: [id],
});
export const createRequestByOrderIndexKey = (orderId, timestamp, requestId) => ({
    first_part: createRequestByOrderIndexFirstPart(orderId),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, requestId],
});
export const createRequestByMarketMakerIndexKey = (marketMaker, timestamp, requestId) => ({
    first_part: createRequestByMarketMakerIndexFirstPart(marketMaker),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, requestId],
});
export const createRefundIndexKey = (timestamp, requestId) => ({
    first_part: createRefundIndexFirstPart(),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, requestId],
});
export const createRefundByMarketMakerIndexKey = (marketMaker, timestamp, requestId) => ({
    first_part: createRefundByMarketMakerIndexFirstPart(marketMaker),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, requestId],
});
export const createNewSwapActionKey = ({ actionId, blockHeight, executionStep, }) => ({
    first_part: createNewSwapActionFirstPart(),
    second_part: [executionStep, blockHeight, actionId],
});
export const createHandledSwapActionKey = (previousKey) => ({
    first_part: createHandledSwapActionFirstPart(),
    second_part: previousKey.second_part,
});
export const createL1TxKey = (timestamp, uniqueId, user) => ({
    first_part: createL1TxInfoFirstPart(user),
    second_part: [Number.MAX_SAFE_INTEGER - timestamp, uniqueId],
});
